module.exports = __webpack_public_path__ + "static/media/[Philm]2010-07-17-2.c693d68f.md";